export const DPI_MAX_BYTES = 20_000_000;
export const DPI_MAX_PIXELS = 16_000_000;
export const DPI_MULTIPART_BYTES = 3_000_000;

/** Replicate p-image-upscale output pricing verified 2026-09-06. */
/** The DPI tool asks for 1 to 8x per side; without a target size 4x. */
export function dpiUpscaleFactor(value: unknown): number {
  const factor = Number(value);
  if (!Number.isFinite(factor)) return 4;
  return Math.min(8, Math.max(1, Math.round(factor * 10) / 10));
}

export function dpiProviderCost(inputPixels: number, factor = 4) {
  if (!Number.isSafeInteger(inputPixels) || inputPixels <= 0 || inputPixels > DPI_MAX_PIXELS) throw new Error('SIZE');
  // factor x on both axes; the model caps the output at 128 MP.
  const outputPixels = Math.min(inputPixels * factor * factor, 128_000_000);
  // Tiers up to 64 MP verified 2026-09-06; the 64-128 MP tier is a cautious estimate.
  return outputPixels <= 4_000_000 ? 0.005 : outputPixels <= 8_000_000 ? 0.01 : outputPixels <= 16_000_000 ? 0.02 : outputPixels <= 32_000_000 ? 0.04 : outputPixels <= 64_000_000 ? 0.06 : 0.12;
}
